const getCurrentMonthRange = () => {
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  
  return [formatDate(firstDay), formatDate(lastDay)];
};

const getPayablesInitialState = () => ({
  filter: {
    filter_due_or_payment_date: getCurrentMonthRange(),
    filter_competency_date: '',
    filter_computed_status: 'all',
    filter_reconciled: '',
    filter_scheduled: '',
    filter_category_id: 'all',
    filter_categories_ids: [],
    filter_bank_accounts_ids: null,
    filter_cost_centers: [],
    filter_projects: [],
    filter_transactions_ids: [],
    filter_externals_ids: [],
    filter_subscription_externals_ids: [],
    filter_externals_ids_null: false,
    filter_subscription_externals_ids_null: false,
    filter_sources: [],
    filter_to_company_id: null,
    filter_show_dre: '',
    filter_installment: '',
    filter_total_installments: '',
    filter_transaction_key: '',
    filter_sale_id: '',
    filter_purchase_id: '',
  },
  sortModel: [
    {
      colId: 'competency_date',
      sort: 'desc',
    },
  ],
  pageSize: 200,
});

export default getPayablesInitialState;
